import { DEFAULT_PUBNUB_MESSAGE_PAGE_SIZE } from 'core/constants';
import { ChatMessagesData } from 'core_main/api/messages/types';
import { getStore } from 'core_main/store';
import { PublicCallback } from 'globals/types';
import { handleError } from 'globals/errors';
import Pubnub from 'pubnub';
import { fetchAndUpdateCurrentUnreadCounts } from 'core_main/api/customers';
import { getConversationPubNub } from '../helpers/instance';
import { PUBNUB_ERROR_CATEGORIES } from '../constants';
import { fetchUnreadCount } from '../helpers/fetchUnreadCount';
import { createConversationChannelGroupString } from '../helpers/channelName';
import { markMessagesAsDelivered } from './chatMessageReceived';

export const markAllMessagesAsDelivered = () => {
  const store = getStore();

  const { orgId, customerId } = store;

  const channelGroup = createConversationChannelGroupString(customerId, orgId);

  getConversationPubNub()?.listChannels(
    { channelGroup },
    (response: Pubnub.ListChannelsResponse) => {
      response.channels.forEach((channel) => {
        getConversationPubNub()?.fetchMessages(
          {
            channels: [channel],
            count: DEFAULT_PUBNUB_MESSAGE_PAGE_SIZE,
            includeMessageActions: true,
            stringifiedTimeToken: true,
            start: 0,
          },
          (fetchMessagesResponse: Pubnub.FetchMessagesResponse) => {
            try {
              const channels = fetchMessagesResponse.channels[channel];

              if (channels?.length) {
                const messagesToMarkAsDelivered = channels.filter((val) => {
                  const message: ChatMessagesData = val?.message?.data;
                  const direction = message?.attributes?.direction;

                  return !val.actions && direction === 'out';
                });

                if (messagesToMarkAsDelivered.length) {
                  const sessionId =
                    messagesToMarkAsDelivered[0]?.message?.data?.relationships
                      ?.session?.data?.id;

                  markMessagesAsDelivered(messagesToMarkAsDelivered, sessionId);
                }
              }
            } catch (error) {
              handleError(error, {
                message: 'Marking all messages as delivered',
              });
            }
          },
        );
      });
    },
  );
};

export const handlePubNubConversationSubscribeOperation = (
  statusEvent: Pubnub.StatusEvent,
  orgId: string,
  customerId: string,
  cb?: PublicCallback,
) => {
  return new Promise((resolve) => {
    if (PUBNUB_ERROR_CATEGORIES.includes(statusEvent.category)) {
      resolve(null);
      return;
    }

    const { affectedChannelGroups } = statusEvent;

    const conversationChannelGroup = createConversationChannelGroupString(
      customerId,
      orgId,
    );

    if (affectedChannelGroups?.includes(conversationChannelGroup)) {
      markAllMessagesAsDelivered();
      const fetchCallback = (allCounts) => {
        if (typeof cb === 'function') cb(allCounts);
        resolve(allCounts);
      };
      // first try to fetch SessionStats via internal api to get unread count
      fetchAndUpdateCurrentUnreadCounts()
        .then(fetchCallback)
        // if the session stats fetch fails, fallback on PubNub to determine unread count
        .catch(() => fetchUnreadCount(fetchCallback));
    } else {
      resolve(null);
    }
  });
};
